<template>
  <div class="buildings">
    <img v-if="src" :src="src" />
    <svg
      v-else
      width="195"
      height="165"
      viewBox="0 0 132 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M131.5 12H11.5L1 49.5L102 111L131.5 62.5V12Z"
        fill="#205640"
        fill-opacity="0.05"
        stroke="#205640"
        stroke-width="0.3"
      />
      <g opacity="0.1">
        <path d="M128 35H125V57H128V35Z" fill="#0F700D" />
        <path d="M123 60.5H117.5V35H123V60.5Z" fill="#0F700D" />
        <path d="M128 35H125V57H128V35Z" stroke="black" stroke-width="0.3" />
        <path
          d="M123 60.5H117.5V35H123V60.5Z"
          stroke="black"
          stroke-width="0.3"
        />
      </g>
      <g opacity="0.1">
        <path d="M115 35H105.5V64H115V35Z" fill="#0F700D" />
        <path d="M103 64V35H80.5V64H95V49.5H98.5V64H103Z" fill="#0F700D" />
        <path d="M78 42H68.5V53.5H71V64H78V42Z" fill="#0F700D" />
        <path d="M115 35H105.5V64H115V35Z" stroke="black" stroke-width="0.3" />
        <path
          d="M103 64V35H80.5V64H95V49.5H98.5V64H103Z"
          stroke="black"
          stroke-width="0.3"
        />
        <path
          d="M78 42H68.5V53.5H71V64H78V42Z"
          stroke="black"
          stroke-width="0.3"
        />
      </g>
      <path
        opacity="0.1"
        d="M24.5 60L27 56.5H33.5V63L31 64L24.5 60Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <g opacity="0.1">
        <path d="M49 75L41 70H49V75Z" fill="#0F700D" />
        <path d="M51.5 76.5V70H65.5V80H60.5V82L51.5 76.5Z" fill="#0F700D" />
        <path
          d="M70 87.5V82V81.5H73V75H68.5V66H75V90.5L70 87.5Z"
          fill="#0F700D"
        />
        <path d="M82 95H88L103 104L101.5 106.5L82 95Z" fill="#0F700D" />
        <path
          d="M92.5 96V95H106.5L107 97L103.7 102.5L92.5 96Z"
          fill="#0F700D"
        />
        <path
          d="M85.5 87V92.5H83.5L77.5 88.5V80H79.5V87H85.5Z"
          fill="#0F700D"
        />
        <path d="M87 92.5V91.5V90.5H91.5V92.5H87Z" fill="#0F700D" />
        <path d="M93.2259 92.5V90.5H101V92.5H93.2259Z" fill="#0F700D" />
        <path
          d="M103 92.5V90.5H104.5L109.5 82.5L111 83.5L105.5 92.5H103Z"
          fill="#0F700D"
        />
        <path d="M114 66H108.5V70H114V66Z" fill="#0F700D" />
        <path d="M99.5 66H106V70H99.5V66Z" fill="#0F700D" />
        <path d="M96.5 70V66H95V70H96.5Z" fill="#0F700D" />
        <path d="M92.5 66H89.5V75H92.5V66Z" fill="#0F700D" />
        <path d="M87.5 66H77.5V73.5H87.5V66Z" fill="#0F700D" />
        <path
          d="M112 78.5L117.5 70H116M41 70L49 75V70H41ZM51.5 70V76.5L60.5 82V80H65.5V70H51.5ZM70 82V87.5L75 90.5V66H68.5V75H73V81.5H70V82ZM88 95H82L101.5 106.5L103 104L88 95ZM92.5 95V96L103.7 102.5L107 97L106.5 95H92.5ZM85.5 92.5V87H79.5V80H77.5V88.5L83.5 92.5H85.5ZM87 91.5V92.5H91.5V90.5H87V91.5ZM93.2259 90.5V92.5H101V90.5H93.2259ZM103 90.5V92.5H105.5L111 83.5L109.5 82.5L104.5 90.5H103ZM108.5 66H114V70H108.5V66ZM106 66H99.5V70H106V66ZM96.5 66V70H95V66H96.5ZM89.5 66H92.5V75H89.5V66ZM77.5 66H87.5V73.5H77.5V66Z"
          stroke="black"
          stroke-width="0.3"
        />
      </g>
      <path
        opacity="0.1"
        d="M120 69.5L113.5 79.5L112 78.5L118 69.5H116V66H120V69.5Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <path
        opacity="0.1"
        d="M124 74.5L112 95L110 93.5L122 73L124 74.5Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <g opacity="0.1">
        <path
          d="M11.5 24H14.4996H15.9996V27.5H20.9996V32H18.4996V30.5H9.52344L11.5 24Z"
          fill="#0F700D"
        />
        <path d="M29 31.5V29.5H38V31.5H29Z" fill="#0F700D" />
        <path d="M59.5 32H42V30H59.5V32Z" fill="#0F700D" />
        <path d="M62 32V30H65.5V32H62Z" fill="#0F700D" />
        <path d="M69 26H72H90.5V32H69V26Z" fill="#0F700D" />
        <path d="M92.5 32V26H96V32H92.5Z" fill="#0F700D" />
        <path d="M98 32V26H99V17H97.5V15.5H100.5V32H98Z" fill="#0F700D" />
        <path d="M102.5 25H104V30H105V32H102.5V25Z" fill="#0F700D" />
        <path d="M127 32V24H125V28.5H123V32H127Z" fill="#0F700D" />
        <path
          d="M11.5 24H14.4996H15.9996V27.5H20.9996V32H18.4996V30.5H9.52344L11.5 24Z"
          stroke="black"
          stroke-width="0.3"
        />
        <path d="M29 31.5V29.5H38V31.5H29Z" stroke="black" stroke-width="0.3" />
        <path d="M59.5 32H42V30H59.5V32Z" stroke="black" stroke-width="0.3" />
        <path d="M62 32V30H65.5V32H62Z" stroke="black" stroke-width="0.3" />
        <path d="M69 26H72H90.5V32H69V26Z" stroke="black" stroke-width="0.3" />
        <path d="M92.5 32V26H96V32H92.5Z" stroke="black" stroke-width="0.3" />
        <path
          d="M98 32V26H99V17H97.5V15.5H100.5V32H98Z"
          stroke="black"
          stroke-width="0.3"
        />
        <path
          d="M102.5 25H104V30H105V32H102.5V25Z"
          stroke="black"
          stroke-width="0.3"
        />
        <path
          d="M127 32V24H125V28.5H123V32H127Z"
          stroke="black"
          stroke-width="0.3"
        />
      </g>
      <path
        opacity="0.1"
        d="M4 47.5L8 34H21.5V45H29V53H33.5V55H22L20.5 57.5L4 47.5Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <path
        opacity="0.1"
        d="M35 34H24V38.5H35V34Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <path
        opacity="0.1"
        d="M56 34H36.5V48.5H65.5V42.5H59.5V38H56V34Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <path
        opacity="0.1"
        d="M37 54V51H41V54H37Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <path
        opacity="0.1"
        d="M50 51H43V54H50V51Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <path
        opacity="0.1"
        d="M65 51H54V54H65V51Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <path
        opacity="0.1"
        d="M65 56H60V60.5H58.5V66H65V56Z"
        fill="#0F700D"
        stroke="black"
        stroke-width="0.3"
      />
      <path
        d="M95 70V75H104V87H86V90.5H104.5L117.5 70H95Z"
        stroke="#205640"
        stroke-width="0.3"
      />
      <path d="M65 17H42V30H65V17Z" stroke="#205640" stroke-width="0.3" />
      <path d="M99 17H72V26H99V17Z" stroke="#205640" stroke-width="0.3" />
      <path
        d="M41.632 2.682L40.645 4.866L39.714 2.682H39.056L40.323 5.573L39.504 7.386H40.148L42.276 2.682H41.632ZM42.5521 6H43.1541C43.2801 5.755 43.3851 5.447 43.4621 5.083C43.5461 4.719 43.5881 4.215 43.5881 3.578V3.228H44.9461V6H45.5551V2.682H42.9791V3.69C42.9791 4.243 42.9441 4.691 42.8671 5.02C42.7971 5.349 42.6921 5.643 42.5521 5.902V6ZM46.4893 5.265V6H47.2173V5.265H46.4893ZM49.9295 6H52.3165C53.2195 6 53.8985 5.454 53.8985 4.586C53.8985 3.718 53.2195 3.179 52.3165 3.179H50.5735V1.709H53.3175V1.1H49.9295V6ZM50.5735 5.391V3.788H52.2885C52.8415 3.788 53.2265 4.103 53.2265 4.586C53.2265 5.069 52.8415 5.391 52.2885 5.391H50.5735ZM54.4965 4.341C54.4965 5.321 55.1755 6.07 56.1765 6.07C57.1705 6.07 57.8635 5.321 57.8635 4.341C57.8635 3.361 57.1845 2.612 56.1765 2.612C55.1755 2.612 54.4965 3.361 54.4965 4.341ZM57.2405 4.341C57.2405 5.041 56.7995 5.524 56.1765 5.524C55.5605 5.524 55.1125 5.034 55.1125 4.341C55.1125 3.648 55.5605 3.158 56.1765 3.158C56.4915 3.158 56.7435 3.27 56.9395 3.494C57.1425 3.711 57.2405 3.998 57.2405 4.341ZM59.2681 6H59.8771V3.228H60.9201V2.682H58.2251V3.228H59.2681V6ZM61.3404 5.055C61.3404 5.363 61.4454 5.608 61.6554 5.797C61.8724 5.979 62.1314 6.07 62.4394 6.07C62.9714 6.07 63.4124 5.832 63.5804 5.475V6H64.1614V3.921C64.1614 3.102 63.6504 2.612 62.7474 2.612C61.9704 2.612 61.4524 3.018 61.3194 3.655L61.8654 3.809C61.9494 3.382 62.2714 3.123 62.7474 3.123C63.2444 3.123 63.5804 3.389 63.5804 3.872V4.215L63.2794 4.131C63.0554 4.061 62.8174 4.026 62.5724 4.026C61.8514 4.026 61.3404 4.376 61.3404 5.055ZM63.5804 4.761C63.5804 5.244 63.1954 5.538 62.6424 5.538C62.2014 5.538 61.9634 5.328 61.9634 5.02C61.9634 4.677 62.2294 4.495 62.6564 4.495C62.8314 4.495 63.0414 4.53 63.2724 4.6L63.5804 4.691V4.761ZM65.6989 2.682H65.0969V6H65.6989V4.572H67.3789V6H67.9879V2.682H67.3789V4.026H65.6989V2.682ZM68.9182 6H69.8422L71.4102 3.27V6H72.0192V2.682H71.0882L69.5202 5.412V2.682H68.9182V6ZM75.2404 4.194C74.9674 4.537 74.6804 4.705 74.2884 4.705C73.8194 4.705 73.5534 4.432 73.5534 3.921V2.682H72.9514V4.033C72.9514 4.754 73.3644 5.223 74.0924 5.223C74.6314 5.223 75.0234 4.999 75.2404 4.691V6H75.8424V2.682H75.2404V4.194ZM79.2085 4.796C79.0755 5.272 78.7605 5.538 78.2495 5.538C77.6615 5.538 77.1995 5.153 77.1925 4.432H79.5935C79.6215 4.306 79.6355 4.173 79.6355 4.026C79.6355 3.592 79.5025 3.249 79.2295 2.997C78.9565 2.738 78.5995 2.612 78.1585 2.612C77.2135 2.612 76.5765 3.368 76.5765 4.32C76.5765 5.391 77.2765 6.07 78.2495 6.07C79.0125 6.07 79.5095 5.671 79.7335 4.999L79.2085 4.796ZM77.1925 3.998C77.2555 3.473 77.6405 3.144 78.1515 3.144C78.6555 3.144 79.0405 3.424 79.0405 3.9L79.0335 3.998H77.1925ZM81.9628 5.538C81.3748 5.538 80.8218 5.062 80.8218 4.32C80.8218 3.557 81.3818 3.144 81.8928 3.144C82.4318 3.144 82.7818 3.452 82.8868 3.977L83.4398 3.809C83.2788 3.053 82.7048 2.612 81.8998 2.612C80.9968 2.612 80.2338 3.326 80.2338 4.32C80.2338 5.37 80.9338 6.07 81.9768 6.07C82.8098 6.07 83.4118 5.587 83.6008 4.747L83.0618 4.544C82.9288 5.167 82.6068 5.538 81.9628 5.538ZM84.2854 6H84.8874V4.516L86.1544 6H86.9244L85.3914 4.25L86.8614 2.682H86.0844L84.8874 4.019V2.682H84.2854V6ZM87.2964 5.055C87.2964 5.363 87.4014 5.608 87.6114 5.797C87.8284 5.979 88.0874 6.07 88.3954 6.07C88.9274 6.07 89.3684 5.832 89.5364 5.475V6H90.1174V3.921C90.1174 3.102 89.6064 2.612 88.7034 2.612C87.9264 2.612 87.4084 3.018 87.2754 3.655L87.8214 3.809C87.9054 3.382 88.2274 3.123 88.7034 3.123C89.2004 3.123 89.5364 3.389 89.5364 3.872V4.215L89.2354 4.131C89.0114 4.061 88.7734 4.026 88.5284 4.026C87.8074 4.026 87.2964 4.376 87.2964 5.055ZM89.5364 4.761C89.5364 5.244 89.1514 5.538 88.5984 5.538C88.1574 5.538 87.9194 5.328 87.9194 5.02C87.9194 4.677 88.1854 4.495 88.6124 4.495C88.7874 4.495 88.9974 4.53 89.2284 4.6L89.5364 4.691V4.761ZM90.815 5.93V6H91.466L92.565 4.67H92.985V6H93.587V2.682H91.928C91.249 2.682 90.843 3.095 90.843 3.676C90.843 3.963 90.941 4.201 91.13 4.39C91.319 4.579 91.557 4.67 91.844 4.67L90.815 5.93ZM92.985 4.145H91.97C91.634 4.145 91.445 3.977 91.445 3.697C91.445 3.41 91.634 3.228 91.97 3.228H92.985V4.145Z"
        fill="#868686"
      />
      <path
        d="M14.4621 65.4749L12.4798 66.822L12.8264 64.4733L12.2652 64.1297L11.836 67.2568L10.1908 68.3753L10.74 68.7116L15.0113 65.8112L14.4621 65.4749ZM13.514 68.7851L14.0274 69.0994C14.2628 68.9563 14.5132 68.7485 14.769 68.4783C15.0307 68.2117 15.3297 67.8038 15.6624 67.2606L15.8451 66.9621L17.0033 67.6713L15.5557 70.0353L16.075 70.3533L17.8077 67.5237L15.6109 66.1784L15.0845 67.0381C14.7957 67.5097 14.5319 67.8734 14.2944 68.1138C14.0629 68.3578 13.8199 68.5537 13.5652 68.7015L13.514 68.7851ZM17.2556 70.2143L16.8717 70.8412L17.4926 71.2213L17.8764 70.5945L17.2556 70.2143ZM19.8055 72.6377L21.8412 73.8842C22.6113 74.3558 23.4754 74.2447 23.9287 73.5045C24.382 72.7642 24.0844 71.95 23.3143 71.4784L21.8279 70.5682L22.5956 69.3146L24.9357 70.7475L25.2537 70.2282L22.3644 68.4589L19.8055 72.6377ZM20.6727 72.4546L21.5099 71.0876L22.9724 71.9832C23.444 72.2719 23.6079 72.7416 23.3556 73.1535C23.1034 73.5655 22.6069 73.639 22.1353 73.3502L20.6727 72.4546ZM24.5667 73.6078C24.0549 74.4436 24.2428 75.4369 25.0965 75.9597C25.9442 76.4788 26.9263 76.2019 27.4381 75.3661C27.9498 74.5304 27.7619 73.5371 26.9023 73.0107C26.0486 72.4879 25.0784 72.7721 24.5667 73.6078ZM26.9068 75.0408C26.5412 75.6378 25.9129 75.8194 25.3816 75.494C24.8563 75.1723 24.7301 74.5205 25.092 73.9295C25.4539 73.3385 26.0918 73.1546 26.6172 73.4763C26.8858 73.6408 27.0422 73.8679 27.0924 74.1613C27.1522 74.4524 27.0859 74.7483 26.9068 75.0408ZM26.9458 77.01L27.4592 77.3244C27.6946 77.1813 27.945 76.9734 28.2007 76.7032C28.4625 76.4367 28.7615 76.0288 29.0941 75.4855L29.2769 75.1871L30.435 75.8962L28.9874 78.2602L29.5068 78.5783L31.2395 75.7486L29.0427 74.4034L28.5163 75.263C28.2275 75.7346 27.9637 76.0984 27.7262 76.3388C27.4947 76.5828 27.2516 76.7787 26.997 76.9265L26.9458 77.01ZM30.3095 79.0698L31.6646 79.8996C32.2377 80.2505 32.8637 80.0593 33.1707 79.5578C33.4815 79.0504 33.3513 78.4454 32.7722 78.0908L31.9305 77.5754L32.5556 76.5545L32.0422 76.2402L30.3095 79.0698ZM31.108 78.9185L31.6417 78.047L32.4595 78.5478C32.7401 78.7196 32.8192 79.006 32.6583 79.2687C32.5011 79.5254 32.2064 79.5912 31.9258 79.4193L31.108 78.9185ZM33.2885 80.894L37.1449 83.2555L38.8776 80.4259L38.3642 80.1115L36.9166 82.4755L35.7585 81.7663L37.2061 79.4023L36.6927 79.0879L35.2451 81.4519L34.087 80.7427L35.5346 78.3787L35.0212 78.0644L33.2885 80.894ZM38.3086 82.86C38.1478 83.1227 38.1094 83.3864 38.1898 83.6573C38.2798 83.9258 38.4531 84.1387 38.7158 84.2995C39.1695 84.5773 39.6699 84.6047 39.9996 84.3879L39.7254 84.8357L40.2209 85.1391L41.3066 83.3661C41.7343 82.6676 41.5544 81.9829 40.7843 81.5113C40.1217 81.1056 39.4679 81.1813 39.0218 81.6551L39.407 82.0716C39.7017 81.7513 40.1115 81.6985 40.5175 81.9471C40.9413 82.2067 41.0889 82.609 40.8367 83.0209L40.6576 83.3134L40.4448 83.0846C40.2903 82.9079 40.1056 82.7538 39.8966 82.6258C39.2818 82.2493 38.6632 82.2809 38.3086 82.86ZM40.3724 83.779C40.1202 84.1909 39.6383 84.2406 39.1667 83.9518C38.7907 83.7215 38.6974 83.4182 38.8582 83.1555C39.0373 82.863 39.3592 82.8467 39.7234 83.0697C39.8726 83.161 40.0334 83.3006 40.1939 83.4809L40.409 83.7193L40.3724 83.779ZM40.8523 85.4437L40.8158 85.5033L41.3709 85.8433L43.0027 85.283L43.3609 85.5023L42.6664 86.6366L43.1798 86.9509L44.9125 84.1213L43.4977 83.255C42.9186 82.9004 42.3567 83.0406 42.0533 83.536C41.9034 83.7808 41.8627 84.0349 41.9252 84.2948C41.9877 84.5547 42.1431 84.7566 42.3879 84.9065L40.8523 85.4437ZM43.6351 85.0546L42.7695 84.5246C42.4829 84.3491 42.4095 84.1071 42.5557 83.8683C42.7056 83.6236 42.9618 83.5671 43.2484 83.7425L44.114 84.2726L43.6351 85.0546ZM50.2193 91.2616L52.7781 87.0828L51.7573 86.4577L48.1075 89.4021L49.071 84.8127L48.0561 84.1913L45.4972 88.3701L46.0465 88.7064L48.4262 84.8201L47.4374 89.5581L48.2731 90.0699L52.0498 87.039L49.6701 90.9253L50.2193 91.2616ZM51.4023 90.8779C51.2414 91.1406 51.203 91.4044 51.2834 91.6752C51.3734 91.9437 51.5468 92.1566 51.8094 92.3174C52.2631 92.5953 52.7635 92.6226 53.0932 92.4059L52.8191 92.8536L53.3145 93.157L54.4002 91.384C54.8279 90.6856 54.648 90.0008 53.8779 89.5293C53.2153 89.1235 52.5615 89.1992 52.1155 89.673L52.5007 90.0895C52.7953 89.7692 53.2052 89.7165 53.6111 89.965C54.0349 90.2246 54.1826 90.6269 53.9303 91.0388L53.7512 91.3313L53.5384 91.1025C53.3839 90.9258 53.1992 90.7717 52.9903 90.6437C52.3754 90.2672 51.7568 90.2989 51.4023 90.8779ZM53.4661 91.797C53.2139 92.2089 52.732 92.2585 52.2604 91.9698C51.8843 91.7395 51.791 91.4361 51.9518 91.1734C52.131 90.8809 52.4528 90.8646 52.817 91.0876C52.9662 91.179 53.1271 91.3185 53.2875 91.4988L53.5026 91.7373L53.4661 91.797ZM55.8451 90.8159L53.3886 94.8276L53.902 95.1419L54.8963 93.5182C54.8936 93.9516 55.1384 94.3559 55.5444 94.6045C56.3144 95.0761 57.2352 94.8191 57.7725 93.9415C58.3099 93.064 58.1501 92.1453 57.386 91.6774C56.9622 91.4179 56.4027 91.42 56.0093 91.647L56.3346 91.1157L55.8451 90.8159ZM55.7423 94.0937C55.3005 93.8232 55.0808 93.1633 55.4646 92.5365C55.8484 91.9097 56.5397 91.7995 56.9815 92.07C57.4471 92.3551 57.654 92.9824 57.2555 93.6331C56.8534 94.2898 56.2079 94.3788 55.7423 94.0937ZM58.8165 98.1513L59.3358 98.4694L60.3045 96.8874C60.3344 97.3079 60.5663 97.6797 60.9245 97.8991C61.6587 98.3487 62.5785 98.0665 63.1013 97.2128C63.6496 96.3174 63.4706 95.4033 62.7482 94.961C62.3363 94.7088 61.8791 94.6914 61.5182 94.9055L62.6185 93.1086L62.0991 92.7906L60.9988 94.5874C61.0194 94.165 60.8021 93.7693 60.3902 93.5171C59.6679 93.0747 58.7724 93.3308 58.224 94.2262C57.7013 95.0799 57.862 96.0238 58.5963 96.4734C58.9545 96.6927 59.3971 96.7339 59.7852 96.5694L58.8165 98.1513ZM60.4328 95.5788C60.0453 96.2116 59.421 96.3464 58.9673 96.0686C58.4659 95.7615 58.3536 95.1674 58.7374 94.5406C59.1176 93.9198 59.7015 93.7437 60.2029 94.0508C60.6566 94.3286 60.8166 94.952 60.4328 95.5788ZM62.5819 96.8948C62.1981 97.5216 61.6238 97.6953 61.1164 97.3846C60.6627 97.1067 60.505 96.493 60.8925 95.8603C61.28 95.2275 61.8983 95.089 62.352 95.3668C62.8534 95.6739 62.9621 96.2739 62.5819 96.8948ZM62.8628 99.0039L63.6508 99.4865L66.4137 97.9771L64.988 100.305L65.5074 100.623L67.2401 97.7937L66.4462 97.3075L63.6833 98.8169L65.109 96.4887L64.5956 96.1743L62.8628 99.0039ZM68.5485 98.5949L68.0351 98.2805L66.3024 101.11L66.8158 101.425L67.5615 100.207L68.9942 101.084L68.2485 102.302L68.7679 102.62L70.5006 99.7903L69.9812 99.4722L69.2794 100.618L67.8467 99.7411L68.5485 98.5949ZM71.1039 103.509C70.6024 103.202 70.3794 102.507 70.7669 101.874C71.1654 101.223 71.8586 101.164 72.2944 101.43C72.7541 101.712 72.8917 102.157 72.7071 102.66L73.2664 102.805C73.5239 102.077 73.2647 101.401 72.5782 100.98C71.8081 100.509 70.7845 100.719 70.2654 101.567C69.7171 102.462 69.9485 103.425 70.838 103.97C71.5484 104.405 72.314 104.307 72.9139 103.689L72.5602 103.235C72.1214 103.697 71.6531 103.845 71.1039 103.509ZM72.8434 105.116L73.3568 105.43L74.1318 104.164L74.4373 106.092L75.094 106.494L74.7005 104.201L76.773 103.631L76.1103 103.225L74.3913 103.741L75.0895 102.6L74.5761 102.286L72.8434 105.116ZM75.9047 105.882C75.7439 106.145 75.7055 106.409 75.7859 106.679C75.8759 106.948 76.0493 107.161 76.3119 107.322C76.7656 107.599 77.266 107.627 77.5957 107.41L77.3215 107.858L77.817 108.161L78.9027 106.388C79.3304 105.69 79.1505 105.005 78.3804 104.533C77.7178 104.128 77.064 104.203 76.6179 104.677L77.0031 105.094C77.2978 104.773 77.7076 104.721 78.1136 104.969C78.5374 105.229 78.685 105.631 78.4328 106.043L78.2537 106.335L78.0409 106.107C77.8864 105.93 77.7017 105.776 77.4928 105.648C76.8779 105.271 76.2593 105.303 75.9047 105.882ZM77.9686 106.801C77.7163 107.213 77.2345 107.263 76.7629 106.974C76.3868 106.744 76.2935 106.44 76.4543 106.178C76.6334 105.885 76.9553 105.869 77.3195 106.092C77.4687 106.183 77.6295 106.323 77.79 106.503L78.0051 106.741L77.9686 106.801ZM78.4484 108.466L78.4119 108.525L78.9671 108.865L80.5989 108.305L80.957 108.524L80.2625 109.659L80.7759 109.973L82.5086 107.143L81.0938 106.277C80.5147 105.922 79.9528 106.063 79.6494 106.558C79.4995 106.803 79.4588 107.057 79.5213 107.317C79.5838 107.577 79.7392 107.779 79.984 107.929L78.4484 108.466ZM81.2312 108.077L80.3656 107.547C80.0791 107.371 80.0056 107.129 80.1518 106.89C80.3017 106.646 80.5579 106.589 80.8445 106.765L81.7101 107.295L81.2312 108.077Z"
        fill="#868686"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.93842 35.5H53.1754L53.3123 35.6096C54.1702 36.2959 56.1865 38.1724 57.4287 40.2428C57.8805 40.9957 57.8982 41.7625 57.4303 42.3504C56.9999 42.8912 56.2536 43.1525 55.4592 43.187C53.8434 43.2573 51.6907 42.4209 50.1 40.3C47.8966 37.3621 44.9341 37.8486 43.7355 38.4413C40.8107 40.1122 36.0833 42.6882 31.3831 44.9987C26.6951 47.3032 21.9746 49.3739 19.1047 49.9889C15.3991 50.783 12.7344 49.3165 11.0214 47.6036C10.1696 46.7517 9.54929 45.8371 9.14103 45.1022C8.93671 44.7344 8.78314 44.4074 8.67912 44.1506C8.62728 44.0226 8.586 43.9077 8.55676 43.8109C8.53341 43.7336 8.49998 43.6131 8.49998 43.5C8.49998 42.9948 8.49795 40.5535 8.0149 38.6213C7.77538 37.6632 8.02404 36.915 8.46813 36.3897C8.89193 35.8884 9.46775 35.6177 9.8787 35.5149L9.93842 35.5ZM10.0665 36.5C9.8143 36.5744 9.47338 36.7495 9.23181 37.0353C8.99257 37.3183 8.82456 37.7368 8.98504 38.3787C9.49249 40.4085 9.49988 42.9113 9.49998 43.4707C9.50215 43.4798 9.50635 43.4963 9.51401 43.5216C9.53213 43.5816 9.56214 43.6669 9.606 43.7752C9.69339 43.991 9.82889 44.2812 10.0152 44.6166C10.3882 45.2879 10.9554 46.1233 11.7285 46.8964C13.2656 48.4335 15.6009 49.717 18.8952 49.0111C21.6254 48.4261 26.2382 46.4135 30.9419 44.1013C35.6267 41.7984 40.3424 39.2285 43.2519 37.5659L43.264 37.559L43.2764 37.5528C44.7523 36.8148 48.3107 36.2477 50.9 39.7C52.3093 41.5791 54.1566 42.2427 55.4158 42.188C56.0589 42.16 56.4688 41.9526 56.6478 41.7277C56.7892 41.55 56.8695 41.2543 56.5712 40.7572C55.4734 38.9276 53.6929 37.2232 52.8219 36.5H10.0665Z"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path d="M11.5 44.5V37.5H22.5V44.5H11.5Z" fill="#DECC9F" />
      <path d="M28.5 37.5H24V44H28.5V37.5Z" fill="#DECC9F" />
      <path d="M35 37.5H30V43.5L35 41V37.5Z" fill="#DECC9F" />
      <path d="M38.5 37.5H36.5V39.5H38.5V37.5Z" fill="#DECC9F" />
      <path
        d="M11.5 44.5V37.5H22.5V44.5H11.5Z"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        d="M28.5 37.5H24V44H28.5V37.5Z"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        d="M35 37.5H30V43.5L35 41V37.5Z"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        d="M38.5 37.5H36.5V39.5H38.5V37.5Z"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <circle
        cx="43"
        cy="44"
        r="3.85"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <circle
        cx="36.5"
        cy="45.5"
        r="2.35"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <circle
        cx="32.5"
        cy="46.5"
        r="1.35"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="60.15"
        y="35.15"
        width="2.7"
        height="5.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="56.15"
        y="35.15"
        width="2.7"
        height="2.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        d="M50.5 43L48 45.5L50.5 48L53 45.5L50.5 43Z"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        d="M54.5 44L52 46.5L54.5 49L57 46.5L54.5 44Z"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        d="M58.5 43L56 45.5L58.5 48L61 45.5L58.5 43Z"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        d="M78.85 38C78.85 38.7706 78.4339 39.4797 77.7384 40.0013C77.0429 40.5229 76.0753 40.85 75 40.85C73.9247 40.85 72.9571 40.5229 72.2616 40.0013C71.5661 39.4797 71.15 38.7706 71.15 38C71.15 37.2294 71.5661 36.5203 72.2616 35.9987C72.9571 35.4771 73.9247 35.15 75 35.15C76.0753 35.15 77.0429 35.4771 77.7384 35.9987C78.4339 36.5203 78.85 37.2294 78.85 38Z"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="82.15"
        y="46.15"
        width="12.7"
        height="3.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="104.15"
        y="46.15"
        width="9.7"
        height="3.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="105.15"
        y="35.15"
        width="10.7"
        height="4.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="117.15"
        y="35.15"
        width="6.7"
        height="4.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="117.15"
        y="41.15"
        width="6.7"
        height="5.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="104.15"
        y="53.5484"
        width="9.7"
        height="3.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="106.15"
        y="49.8492"
        width="9.7"
        height="3.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="106.15"
        y="57.2477"
        width="9.7"
        height="3.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="82.15"
        y="52.15"
        width="12.7"
        height="3.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="82.15"
        y="58.15"
        width="12.7"
        height="3.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="97.15"
        y="57.15"
        width="5.7"
        height="5.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="97.15"
        y="46.15"
        width="5.7"
        height="9.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M85.0938 35.5079C84.2208 35.334 82.9011 35.2449 81.82 35.5991C81.2705 35.7791 80.7445 36.0865 80.3904 36.5946C80.0308 37.1108 79.8917 37.772 80.0057 38.5699C80.2515 40.2909 80.5097 41.9211 81.3417 43.1004C82.2172 44.3411 83.6521 45 85.9999 45H116.541L116.582 44.9932C116.932 44.9349 117.551 45.0152 118.136 45.555C118.719 46.0932 119.31 47.1296 119.502 49.0498C119.71 51.1254 120.37 52.3634 121.219 53.0204C122.07 53.6789 123.024 53.6856 123.658 53.4743L123.973 53.3694L123.998 53.0383C124.166 50.8654 124.366 47.5301 124.425 44.5841C124.454 43.1123 124.448 41.7284 124.383 40.6321C124.351 40.0847 124.304 39.5986 124.236 39.2044C124.173 38.8335 124.08 38.4677 123.916 38.2218C123.582 37.7208 123.029 37.3872 122.415 37.1943C121.796 36.9996 121.072 36.9339 120.33 37.0013C118.849 37.1357 117.211 37.8091 116.109 39.1869C115.214 40.3071 114.108 40.7557 112.79 40.8132C111.442 40.872 109.886 40.5193 108.137 40.0193L104.614 39.0115L85.0938 35.5079ZM81.2109 37.1663C81.0247 37.4335 80.9096 37.8264 80.9956 38.4285C81.2498 40.2076 81.4913 41.5777 82.1588 42.5239C82.783 43.4085 83.8477 44 85.9999 44H116.461C117.109 43.9062 118.017 44.0848 118.814 44.82C119.631 45.5735 120.289 46.8704 120.497 48.9502C120.69 50.8746 121.28 51.8033 121.831 52.2296C122.243 52.5485 122.682 52.6242 123.029 52.5905C123.189 50.433 123.37 47.3229 123.425 44.5642C123.454 43.1025 123.448 41.7488 123.385 40.6909C123.354 40.1613 123.309 39.7161 123.25 39.3734C123.188 39.0073 123.12 38.8305 123.084 38.7767C122.918 38.528 122.596 38.2992 122.116 38.1483C121.641 37.9992 121.052 37.9398 120.42 37.9972C119.151 38.1123 117.788 38.6885 116.89 39.8115C115.786 41.1921 114.392 41.7443 112.834 41.8122C111.308 41.8788 109.613 41.4814 107.862 40.9807L104.387 39.9869L84.9026 36.4896C84.1089 36.3309 82.9815 36.2709 82.1313 36.5494C81.7142 36.686 81.4027 36.8911 81.2109 37.1663Z"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <circle
        cx="75"
        cy="43.5"
        r="1.85"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <rect
        x="71.15"
        y="46.15"
        width="6.7"
        height="17.7"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        d="M68.0295 29.0367C69.62 27.3046 68.3608 24.7064 67.5325 23.6239L69.5212 22C70.3494 23.8043 72.9003 27.4688 70.5146 30.5C69.0242 32.3937 66.6346 33.367 67.0354 36.5C67.2913 38.5 70.4343 40.4346 71.4997 41.5C72.5652 42.5654 74.7234 46.2311 70.5146 48.5229C67.3337 50.255 68.8579 53.2141 70.0176 54.4771C71.0117 55.7401 72.9997 58.8073 72.9997 60.9725C72.9997 63.6789 70.0176 68.0092 64.5503 69.0917C61.2071 69.7537 60.4997 71 62.0652 72.3394L69.5212 77.7523L67.5325 81C65.3789 79.3761 60.5752 75.3704 58.5867 72.3394C56.365 68.953 62.0244 67.5826 66.0006 66.5C69.1816 65.6339 69.6869 62.2355 69.5212 60.4312C69.5212 57 68.8751 54.4319 66.5391 52.3119C64.1534 50.1468 65.006 48.2217 66 47.5L68.0295 46.3578C71.2099 44.6257 69.6864 42.7492 68.5272 42.0275L67.0354 40.945C63.0592 37.9138 63.7219 34.63 64.5503 33.367C65.0473 32.6453 66.439 30.7688 68.0295 29.0367Z"
        fill="#DECC9F"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path
        d="M95.5 31.9998H73.5C73.5 31.9998 79.5411 27.6421 84 27.4998C88.8202 27.346 95.5 31.9998 95.5 31.9998Z"
        fill="#DECC9F"
      />
      <path d="M70 17H67V28H70V17Z" fill="#DECC9F" />
      <path
        d="M95.5 31.9998H73.5C73.5 31.9998 79.5411 27.6421 84 27.4998C88.8202 27.346 95.5 31.9998 95.5 31.9998Z"
        stroke="#CEB56A"
        stroke-width="0.3"
      />
      <path d="M70 17H67V28H70V17Z" stroke="#CEB56A" stroke-width="0.3" />
      <path
        d="M48.464 21.016C49.176 21.016 49.648 21.368 49.832 22.04L50.52 21.648C50.224 20.808 49.456 20.32 48.528 20.32C47.4 20.32 46.64 20.992 46.64 21.816C46.64 22.704 47.288 23.264 48.584 23.488C49.632 23.656 49.992 23.944 49.992 24.448C49.992 25.016 49.456 25.384 48.648 25.384C47.744 25.384 47.136 24.864 46.912 23.944L46.232 24.368C46.424 24.976 46.744 25.416 47.184 25.68C47.624 25.944 48.112 26.08 48.64 26.08C49.872 26.08 50.752 25.384 50.752 24.424C50.752 23.552 50.16 23.08 48.84 22.824C47.912 22.64 47.376 22.352 47.376 21.8C47.376 21.32 47.832 21.016 48.464 21.016ZM52.3753 23.696H54.1113C55.2393 23.696 55.9273 22.936 55.9273 22.048C55.9273 21.136 55.2713 20.4 54.1113 20.4H51.6393V26H52.3753V23.696ZM52.3753 23V21.096H54.0473C54.7113 21.096 55.1513 21.44 55.1513 22.048C55.1513 22.656 54.7113 23 54.0473 23H52.3753ZM55.6665 26H56.4745L57.0585 24.576H59.9865L60.5625 26H61.3785L59.0345 20.4H58.0105L55.6665 26ZM57.3225 23.904L58.5225 20.984L59.7145 23.904H57.3225Z"
        fill="#3F4440"
      />

      <!-- 1 -->
      <g :class="['g', { active: current == 1 }]">
        <path
          class="path"
          d="M60 54H37V66H54.617V64.5H58.5319V60H60V54Z"
          fill="#F4F7F5"
          stroke="#205640"
          stroke-width="0.3"
        />
        <path
          class="path-shadow"
          d="M37 59.5V54H42.5V57H40V59.5H37Z"
          fill="#DFE7E3"
          stroke="#205640"
          stroke-width="0.3"
        />
        <path
          class="path-text"
          d="M47.024 59.592L49.08 57.4H48.128L45.344 60.392V57.4H44.608V63H45.344V61.384L46.52 60.136L48.304 63H49.184L47.024 59.592ZM50.7661 63H51.4621V57.4H50.8461C50.6541 58.168 50.0781 58.624 49.2541 58.712L49.3901 59.424C49.6701 59.4 49.9341 59.304 50.1981 59.136C50.4621 58.968 50.6541 58.752 50.7661 58.496V63Z"
          fill="#3F4440"
        />
      </g>

      <!-- 2 -->
      <g :class="['g', { active: current == 2 }]">
        <path
          class="path"
          d="M38 17H14V24.28H16.0426V27.4H20.6383V30H38V17Z"
          fill="#F4F7F5"
          stroke="#205640"
          stroke-width="0.3"
        />
        <path
          class="path-shadow"
          d="M38 21V17H34L38 21Z"
          fill="#DFE7E3"
          stroke="#205640"
          stroke-width="0.3"
        />
        <path
          class="path-text"
          d="M26.024 22.592L28.08 20.4H27.128L24.344 23.392V20.4H23.608V26H24.344V24.384L25.52 23.136L27.304 26H28.184L26.024 22.592ZM30.367 23.752C29.399 24.232 28.815 24.872 28.815 26H32.639V25.352H29.679C29.743 24.968 30.079 24.648 30.431 24.448C30.615 24.344 30.887 24.192 31.263 23.992C32.167 23.536 32.631 23 32.631 22.08C32.631 21.048 31.903 20.32 30.679 20.32C29.479 20.32 28.695 21.136 28.695 22.12C28.695 22.56 28.839 22.96 29.119 23.328L29.711 22.944C29.503 22.688 29.399 22.4 29.399 22.072C29.399 21.464 29.919 20.944 30.647 20.944C31.439 20.944 31.935 21.416 31.935 22.112C31.935 22.632 31.679 22.976 31.255 23.256C31.047 23.392 30.751 23.552 30.367 23.752Z"
          fill="#3F4440"
        />
      </g>

      <!-- 4 -->
      <g :class="['g', { active: current == 4 }]">
        <path
          class="path"
          d="M127 17H104V30H120V28.375H125V24.0417H127V17Z"
          fill="#F4F7F5"
          stroke="#205640"
          stroke-width="0.3"
        />
        <path
          class="path-shadow"
          d="M104 22.5V17H109.5V20H107V22.5H104Z"
          fill="#DFE7E3"
          stroke="#205640"
          stroke-width="0.3"
        />
        <path
          class="path-text"
          d="M113.024 22.592L115.08 20.4H114.128L111.344 23.392V20.4H110.608V26H111.344V24.384L112.52 23.136L114.304 26H115.184L113.024 22.592ZM117.863 26H118.559V24.568H119.511V23.944H118.559V22.128H117.863V23.944H116.079C116.519 23.504 116.815 23.04 116.983 22.536C117.151 22.032 117.239 21.44 117.239 20.76V20.4H116.543V20.76C116.527 22.2 116.343 22.856 115.343 23.84V24.568H117.863V26Z"
          fill="#3F4440"
        />
      </g>

      <!-- 5 -->
      <g :class="['g', { active: current == 5 }]">
        <path
          class="path"
          d="M104 75H86.5V76H83V79.5H80V87H104V75Z"
          fill="#F4F7F5"
          stroke="#205640"
          stroke-width="0.3"
        />
        <path
          class="path-shadow"
          d="M104 82L104 87L99 87L99 84.2727L101.273 84.2727L101.273 82L104 82Z"
          fill="#DFE7E3"
          stroke="#205640"
          stroke-width="0.3"
        />
        <path
          class="path-text"
          d="M90.024 80.592L92.08 78.4H91.128L88.344 81.392V78.4H87.608V84H88.344V82.384L89.52 81.136L91.304 84H92.184L90.024 80.592ZM96.434 78.4H92.922C92.922 79.352 92.842 80.36 92.682 81.408L93.418 81.576C93.61 81.16 94.13 80.832 94.682 80.832C95.538 80.832 95.994 81.36 95.994 82.12C95.994 82.88 95.498 83.432 94.634 83.432C93.866 83.432 93.41 83 93.29 82.24L92.618 82.432C92.69 82.96 92.906 83.368 93.282 83.656C93.658 83.936 94.106 84.08 94.634 84.08C95.898 84.08 96.69 83.232 96.69 82.04C96.69 80.888 95.874 80.208 94.842 80.208C94.226 80.208 93.698 80.472 93.37 80.848C93.506 80.168 93.57 79.568 93.57 79.048H96.434V78.4Z"
          fill="#3F4440"
        />
      </g>

      <!-- 6 -->
      <g :class="['g', { active: current == 6 }]">
        <path
          class="path"
          d="M98.9093 17H71.9835V26H98.9093V17Z"
          fill="#F4F7F5"
          stroke="#205640"
          stroke-width="0.3"
        />
        <path
          class="path-text"
          d="M83.6094 20.9266L85.5025 18.8601H84.626L82.0626 21.6808V18.8601H81.3849V24.1396H82.0626V22.616L83.1454 21.4395L84.788 24.1396H85.5983L83.6094 20.9266Z"
          fill="#3F4440"
        />
        <path
          class="path-text"
          d="M85.8028 21.5375C85.8028 23.0987 86.4731 24.215 87.7843 24.215C88.7787 24.215 89.508 23.4834 89.508 22.42C89.508 21.5074 88.845 20.7456 87.8506 20.7456C87.2613 20.7456 86.6794 21.0925 86.4363 21.5979V21.4923C86.4363 20.0442 87.0551 19.373 87.7769 19.373C88.4251 19.373 88.8008 19.7048 88.8966 20.376L89.5006 20.1875C89.3827 19.3352 88.7935 18.7847 87.8138 18.7847C86.4805 18.7847 85.8028 20.0065 85.8028 21.5375ZM88.8745 22.4803C88.8745 23.144 88.4178 23.6041 87.7696 23.6041C87.0993 23.6041 86.6205 23.144 86.6205 22.4577C86.6205 21.8015 87.1287 21.3339 87.7254 21.3339C88.3957 21.3339 88.8745 21.7864 88.8745 22.4803Z"
          fill="#3F4440"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      current: this.$route.params.korp,
    };
  },
};
</script>

<style scoped>
.g.active {
  --green-dark: #71ae60;
  --green-shadow: #69a55d;
}

.g.active .path {
  fill: var(--green-dark);
}

.g.active .path-shadow {
  fill: var(--green-shadow);
}

.g.active .path-text {
  fill: #fff;
}
</style>
